import React, {FC} from 'react';

import {parseAccountFilter} from '../../../../../srcCommon/inboxes/search/searchHelpers';
import {SearchNoResultsAccount} from './searchNoResultsAccount';
import {SearchNoResultsMessage, SearchNoResultsMessageProps} from './searchNoResultsMessage';

/*
 * Props.
 */

interface SearchNoResultsProps extends Omit<SearchNoResultsMessageProps, 'hasImprovedEmptyState'> {}

/*
 * Component.
 */

export const SearchNoResults: FC<SearchNoResultsProps> = (props) => {
  const {panelId, parameters, cellsContext, navigateToSearch} = props;
  const {
    search: {query},
  } = parameters;

  // If the query contains the `account` modifier, maybe render a message to update that account.
  const accountAlias = query && parseAccountFilter(query);
  if (accountAlias) {
    return (
      <SearchNoResultsAccount
        panelId={panelId}
        accountAlias={accountAlias}
        parameters={parameters}
        cellsContext={cellsContext}
        navigateToSearch={navigateToSearch}
      />
    );
  }

  return (
    <SearchNoResultsMessage
      panelId={panelId}
      parameters={parameters}
      cellsContext={cellsContext}
      navigateToSearch={navigateToSearch}
    />
  );
};
